// extracted by mini-css-extract-plugin
export default {"link":"FooterLinks_link__ea9Eo text_small-uppercase__QyMyt","wrap":"FooterLinks_wrap__vvHkn"};